import { store } from '@/decorators/store';
import { Unit } from '@/entities/Unit';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'UnitStore' })
export class UnitStore extends AbstractEntityStore<Unit> {
  protected entityIdKey = 'vehicle.vehicleId';
  protected entityValueKey = 'name';
}
